import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useCreateCatalogItem = () => {
  return useMutation({
    mutationFn: (data) => api.referral.createCatalogItem(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось создать событие',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Событие успешно создано',
        type: 'success',
      })
    }
  })
}
